var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrow2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 63,
    viewBox: "0 0 142 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.7454L20.2744 23.8035L19.7138 0.716289L0 12.7454ZM138 61C138 62.1046 138.895 63 140 63C141.105 63 142 62.1046 142 61H138ZM18.0003 12.3083L18.0416 14.3079C62.6566 13.3856 92.7675 14.2606 111.732 20.8575C121.127 24.1253 127.611 28.7436 131.786 35.11C135.978 41.502 138 49.894 138 61H140H142C142 49.4454 139.902 40.1906 135.131 32.9164C130.344 25.6167 123.022 20.5495 113.047 17.0795C93.2711 10.2006 62.3821 9.39037 17.9589 10.3087L18.0003 12.3083Z",
    fill: "#FF671F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrow2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Arrow2.a42a646d0261ce2a755542ec3a750664.svg";